import React from 'react'
import {useParams, useHistory} from 'react-router-dom'
import useAccount from 'admin/hooks/useAccount'
import useStateObject from 'admin/hooks/useStateObject'
import useDocument from 'admin/hooks/useDocument'
import InputField from 'admin/components/shared/InputField'
import Modal from 'admin/components/shared/Modal'
import Header from '../shared/Header'
import useModal from '../../hooks/useModal'

export default () => {
  const {organisationID} = useParams()
  const history = useHistory()
  const {popModal} = useModal()
  const {account, errors, create} = useAccount(organisationID)
  const [form, setForm, resetForm] = useStateObject(account)

  useDocument({title: 'New account'})

  const handleCreate = e => {
    e.preventDefault()
    create(form, ({account}) => {
      history.replace(`/orgs/${organisationID}/accounts/${account.id}`)
    })
  }

  const handleClose = e => {
    e.preventDefault()
    resetForm(account)
    popModal('new-account')
  }

  return (
    <Modal onClose={handleClose} flashId='new-account'>
      <Header title='New account'>
        <button className='button is-primary' onClick={handleCreate}>
          Create
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <form onSubmit={handleCreate}>
            <InputField type='text' name='name' value={form.name || ''} onChange={setForm} errors={errors.name} />
          </form>
        </div>
      </section>
    </Modal>
  )
}
